(() => {
  'use strict';
  const root = document.getElementById('babazac-approved');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const rest = () => { $('#heroSection').classList.add('loaded'); $$('.reveal').forEach(e=>e.classList.add('in')); $('.final-cta').classList.add('in'); };
  const load = () => $('#heroSection').classList.add('loaded');
  if (document.readyState === 'complete') load(); else window.addEventListener('load', load, {once:true});
  const header = $('#siteHeader');
  const nav = () => header.classList.toggle('solid', window.scrollY > 40);
  window.addEventListener('scroll', nav, {passive:true}); nav();
  if (reduced.matches || !('IntersectionObserver' in window)) rest();
  else {
    // Exact approved observer timing, including the separate final-CTA observer.
    const io = new IntersectionObserver(entries=>entries.forEach(e=>{
      if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}
    }),{threshold:0.15});
    $$('.reveal').forEach(e=>io.observe(e));
    const ctaSection=$('.final-cta');
    const ctaIo=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(e.isIntersecting){setTimeout(()=>ctaSection.classList.add('in'),700);ctaIo.unobserve(e.target);}
    }),{threshold:0.3});
    ctaIo.observe(ctaSection);
  }
  const videos=$$('video');
  const play=async v=>{
    v.muted=true;v.defaultMuted=true;v.playsInline=true;
    if(reduced.matches){v.pause();v.removeAttribute('autoplay');return;}
    if(!v.dataset.hydrated){
      let changed=false;
      if(v.dataset.src){v.src=v.dataset.src;changed=true;}
      v.querySelectorAll('source[data-src]').forEach(s=>{s.src=s.dataset.src;changed=true;});
      v.dataset.hydrated='true';if(changed)v.load();
    }
    try{await v.play();v.dataset.autoplay='playing';}
    catch{v.dataset.autoplay='blocked'; /* poster remains visible; no forced audio */}
  };
  if('IntersectionObserver' in window){
    const vio=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(e.isIntersecting) play(e.target);else e.target.pause();
    }),{rootMargin:'150px 0px',threshold:0});
    videos.forEach(v=>{v.muted=true;v.defaultMuted=true;v.playsInline=true;if(reduced.matches)v.removeAttribute('autoplay');vio.observe(v);});
  }else videos.forEach(play);
  videos.forEach(v=>v.addEventListener('error',()=>{v.pause();v.dataset.autoplay='failed';}));
  document.addEventListener('visibilitychange',()=>videos.forEach(v=>{
    if(document.hidden)v.pause();else {const r=v.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight)play(v);}
  }));
  reduced.addEventListener('change',()=>{if(reduced.matches){rest();videos.forEach(v=>v.pause());}});
  const config=JSON.parse(document.getElementById('bzCommerceData').textContent);
  const names={gold:'Gold',rosegold:'Rose Gold',silver:'Silver',black:'Matte Black'};
  const swatches=$$('.swatch'),layers=$$('.colors-media .cm-bg,.colors-media .cm-fg');
  const form=$('#bzPurchaseForm'),button=$('#atc'),input=$('#bzVariant'),price=$('#bzPrice'),status=$('#bzCommerceStatus');
  let selected=config.initial||'gold',generation=0,submitting=false;
  const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:config.currency});
  const report=text=>{status.textContent=text;status.hidden=!text;};
  const oneVariant=p=>{
    // Fail closed if the merchant later adds a size/option: never guess a variant.
    if(!p||p.variants?.length!==1||!p.variants[0]?.id)throw Error('This finish is unavailable. Please try again later.');
    return p.variants[0];
  };
  const fetchProduct=async color=>{
    const p=config.products[color];
    if(!p?.handle)throw Error('This finish is unavailable. Please try again later.');
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),12000);
    try{
      const response=await fetch(`${config.root}products/${encodeURIComponent(p.handle)}.js`,{cache:'no-store',credentials:'same-origin',headers:{Accept:'application/json'},signal:controller.signal});
      if(!response.ok)throw Error('Unable to load this finish. Please try again.');
      return await response.json();
    }finally{clearTimeout(timer);}
  };
  const show=p=>{
    const v=oneVariant(p);input.value=String(v.id);form.dataset.variant=String(v.id);price.textContent=money.format(v.price/100);
    button.disabled=!v.available;
    report(v.available?'':'This finish is currently unavailable.');
    return v;
  };
  const select=async c=>{
    if(submitting)return;
    selected=c;const ticket=++generation;
    swatches.forEach(s=>{s.classList.toggle('active',s.dataset.c===c);s.setAttribute('aria-pressed',String(s.dataset.c===c));});
    layers.forEach(img=>img.classList.toggle('active',img.dataset.c===c));
    $('#colorName').textContent=names[c];
    button.disabled=true;input.value='';price.textContent='';report('');
    try{const p=await fetchProduct(c);if(ticket===generation)show(p);}
    catch(e){if(ticket===generation)report(e.message);}
  };
  swatches.forEach(s=>{s.setAttribute('aria-label',names[s.dataset.c]);s.addEventListener('click',()=>select(s.dataset.c));});
  form.addEventListener('submit',async e=>{
    e.preventDefault();if(submitting||button.disabled)return;
    submitting=true;button.disabled=true;swatches.forEach(s=>s.disabled=true);report('');
    try{
      const p=await fetchProduct(selected);const v=show(p);
      if(!v.available)throw Error('This finish is currently unavailable.');
      button.disabled=true;
      const response=await fetch(`${config.root}cart/add.js`,{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:v.id,quantity:1}]})
      });
      if(!response.ok)throw Error('Unable to add this finish. Please try again.');
      window.location.assign(`${config.root}cart`);
    }catch(err){submitting=false;button.disabled=false;swatches.forEach(s=>s.disabled=false);report(err.message);}
  });
  select(selected);
})();
